import script from "./Show.vue?vue&type=script&setup=true&lang=ts"
export * from "./Show.vue?vue&type=script&setup=true&lang=ts"

import "./Show.vue?vue&type=style&index=0&id=29fc5a48&scoped=true&lang=css"
import "./Show.vue?vue&type=style&index=1&id=29fc5a48&lang=scss"

import exportComponent from "/codebuild/output/src669166032/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29fc5a48"]])

export default __exports__